import { Box, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import LiveContinueStyle from "./style";

import { IDesginItem } from "@/api/types/home-ui";

export default function LiveHorizontal({ data }: { data: IDesginItem[] }) {
    return (
        <LiveContinueStyle className="horizontal-wrapper">
            <Typography className="title">Popular Series</Typography>
            <Box className="horizontal-list">
                <Swiper
                    className="mySwiper"
                    modules={[Pagination]}
                    pagination={{
                        clickable: true,
                    }}
                    slidesPerView={2}
                    spaceBetween={10}
                >
                    {data.map((item) => {
                        const { thumbnailPortrait, ml_name, length } = item;

                        return (
                            <SwiperSlide key={item.id}>
                                <Box className="horizontal-box">
                                    <img alt={ml_name?.en} src={thumbnailPortrait?.url} />
                                    <Typography className="text">
                                        <span className="name">{ml_name?.en}</span>
                                        <span className="length">{length}</span>
                                    </Typography>
                                </Box>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </Box>
        </LiveContinueStyle>
    );
}
